import type { ReactNode } from 'react';
import type { FeedbackSupplierProfile } from '@erp/rpc';

import { FeedbackSupplierContext } from './feedbackSupplierContext';

/** Provides the card's supplier to its parts; see `feedbackSupplierContext`. */
export function FeedbackSupplierProvider({
  supplier,
  children,
}: {
  supplier: FeedbackSupplierProfile;
  children: ReactNode;
}) {
  return (
    <FeedbackSupplierContext.Provider value={supplier}>
      {children}
    </FeedbackSupplierContext.Provider>
  );
}
